/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert between centrifuge RPM and relative centrifugal force (RCF / g).`)
};

const es_gf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte entre RPM de centrífuga y fuerza centrífuga relativa (RCF / g).`)
};

const de_gf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umrechnung zwischen Zentrifugen-RPM und relativer Zentrifugalkraft (RCF / g).`)
};

const nl_gf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reken om tussen centrifuge-RPM en relatieve centrifugale kracht (RCF / g).`)
};

const fr_gf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir entre les RPM d'une centrifugeuse et la force centrifuge relative (RCF / g).`)
};

const it_gf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti tra RPM della centrifuga e forza centrifuga relativa (RCF / g).`)
};

const pt_br2_gf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta entre RPM da centrífuga e força centrífuga relativa (RCF / g).`)
};

const pt_gf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta entre RPM da centrífuga e força centrífuga relativa (RCF / g).`)
};

const ja_gf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遠心分離機のRPMと相対遠心力(RCF / g)を相互に変換します。`)
};

const zh_gf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在离心机转速 (RPM) 与相对离心力 (RCF / g) 之间进行换算。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_tool_description", locale)
	if (locale === "en") return en_gf_tool_description(inputs)
	if (locale === "es") return es_gf_tool_description(inputs)
	if (locale === "de") return de_gf_tool_description(inputs)
	if (locale === "nl") return nl_gf_tool_description(inputs)
	if (locale === "fr") return fr_gf_tool_description(inputs)
	if (locale === "it") return it_gf_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_gf_tool_description(inputs)
	if (locale === "pt") return pt_gf_tool_description(inputs)
	if (locale === "ja") return ja_gf_tool_description(inputs)
	return zh_gf_tool_description(inputs)
};